


/*
 * @Description: 动态扩散墙的墙体效果（参考开源代码）（不同高度透明度不同）
 * @Version: 1.0
 * @Author: Julian
 * @Date: 2022-03-07 19:50:46
 * @LastEditors: Julian
 * @LastEditTime: 2022-03-07 19:56:30
 */
//颜色  重复次数  偏移 线宽占比  周期时间
class RadarRadiationWaveMaterialProperty {
    constructor(options) {
        this._definitionChanged = new Cesium.Event();
        this._color = undefined;
        this.color = options.color;
        this.repeat = options.repeat; //重复次数
        this.offset = options.offset; //偏移
        this.thickness = options.thickness; //线宽占比
        this.duration = options.duration || 1000; //周期时间
        this._time = (new Date()).getTime();
    };

    get isConstant() {
        return false;
    }

    get definitionChanged() {
        return this._definitionChanged;
    }

    getType(time) {
        return  Cesium.Material.RadarRadiationWaveType;
    }

    getValue(time, result) {
        if (!Cesium.defined(result)) {
            result = {};
        }

        result.color = Cesium.Property.getValueOrDefault(this._color, time, Cesium.Color.RED, result.color);
        result.repeat = Cesium.Property.getValueOrDefault(this.repeat, time, 1, result.repeat);
        result.offset = Cesium.Property.getValueOrDefault(this.offset, time, 0, result.offset);
        result.thickness = Cesium.Property.getValueOrDefault(this.thickness, time, 0.8, result.thickness);
        result.time = (((new Date()).getTime() - this._time) % this.duration) / this.duration / 10;
        return result
    }

    equals(other) {
        return (this === other ||
            (other instanceof RadarRadiationWaveMaterialProperty &&
                Cesium.Property.equals(this._color, other._color) &&
                Cesium.Property.equals(this.repeat, other.repeat) &&
                Cesium.Property.equals(this.offset, other.offset) &&
                Cesium.Property.equals(this.thickness, other.thickness))
        )
    }
}

Object.defineProperties(RadarRadiationWaveMaterialProperty.prototype, {
    color: Cesium.createPropertyDescriptor('color'),
    repeat: Cesium.createPropertyDescriptor('repeat'),
    offset: Cesium.createPropertyDescriptor('offset'),
    thickness: Cesium.createPropertyDescriptor('thickness'),
})

export default RadarRadiationWaveMaterialProperty
